import { ChangeDetectionStrategy, Component, Input, OnInit, Renderer2 } from '@angular/core'

import { PaymentSources } from '../../../../enums/enums'
import { ICartGroup } from '../../../../services/cart.service'
import { CurrencySignType, I18nService, LgType } from '../../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-payment-block',
  templateUrl: './bmcore-payment-block.component.html',
  styleUrls: ['./bmcore-payment-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcorePaymentBlockComponent implements OnInit {
  @Input() group: ICartGroup
  @Input() paymentSource: PaymentSources
  @Input() colorSettingsMode = false
  @Input() widgetId: number

  lg: LgType
  currencySign: CurrencySignType
  isConfirmationOrderPopup = false

  constructor(
    private renderer: Renderer2,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.currencySign = this.i18nService.getCurrencySign()
    this.lg = this.i18nService.getLanguageForPage()
  }

  switchConfirmationOrderPopup(value: boolean) {
    this.isConfirmationOrderPopup = value

    /* No parent scroll on modal scroll */
    this.renderer.addClass(document.body, 'modal-open')
  }
}
